<template>
  <PForm
    v-model="validado"
    @cancel="cancel"
    @accept="action"
    :action="actionName"
    :textAction="textActionName"
    :readonly="!valueLocal.desCliente"
  >
    <template #default="{ validar }">
      <div>
        <PRow v-if="!valueLocal.desCliente">
          <PCol col="6">
            <PFormSelect
              v-model="valueLocal.pais"
              :options="optionsPaises"
              optionValue="id"
              optionText="descripcion"
              :label="$t('label.pais')"
              :placeholder="$t('option.select')"
              rules="required"
              @input="validar"
              @change="fetchDelegaciones"
              invalid_feedback="Obligatorio"
            />
          </PCol>
          <PCol col="6">
            <PFormInputText
              v-model="valueLocal.codCliente"
              :label="$t('label.codCliente')"
              rules="required|max:10"
            />
          </PCol>
        </PRow>
        <PRow v-if="!valueLocal.desCliente">
          <PCol
            md="12"
            class="divBotonValidar_ClienteForm"
            v-if="valueLocal.codCliente != '' && valueLocal.pais != '' && actionName === 'crear'"
          >
            <PButton @click="validarCliente">{{ $t("label.validar") }}</PButton>
          </PCol>
        </PRow>
        <PRow v-if="valueLocal.desCliente">
          <PCol md="12">
            <PDataLine
              :value="{
                codCliente: valueLocal.codCliente,
                desCliente: valueLocal.desCliente,
              }"
              :fields="{
                codCliente: { title: $t('label.codCliente'), width: '50%' },
                desCliente: { title: $t('label.cliente'), width: '50%' },
              }"
              :showBorder="true"
            />
          </PCol>
        </PRow>
        <PRow>
          <PCol md="12" v-if="valueLocal.desCliente">
            <PFormSelectTranslateItems
              v-model="valueLocal.delegaciones"
              :options="optionsDelegaciones"
              optionValue="id"
              optionText="desDelegacion"
              rules="required"
              @change="validar"
              :titleLeft="$t('label.delegacion')"
              :titleRight="$t('label.seleccionadas')"
            />
          </PCol>
        </PRow>
        <PRow>
          <PCol col="6" v-if="valueLocal.desCliente">
            <PFormSwitch v-model="valueLocal.fakeCerts" :label="$t('label.fakeCerts')" />
          </PCol>
          <PCol col="6" v-if="valueLocal.desCliente">
            <PFormSwitch v-model="valueLocal.active" :label="$t('label.activo')" />
          </PCol>
        </PRow>
        <PRow>
          <PCol col="6" v-if="valueLocal.desCliente">
            <PFormSwitch v-model="valueLocal.intraDay" :label="$t('label.intraday')" />
          </PCol>
        </PRow>
        <PRow>
          <PCol col="6" v-if="valueLocal.desCliente">
            <label class="label-form d-block" for="select-hora-expiracion"
              >{{ $t("label.hora.expiracion") }}
            </label>
            <b-time
              id="select-hora-expiracion"
              name="select-hora-expiracion"
              v-model="valueLocal.expirationTime"
              aria-describedby="fecha-hora-feedback"
              :hide-header="true"
            />
          </PCol>
        </PRow>
        <PRow>
          <PCol col="12">
            <PFormSwitch
              v-model="valueLocal.ntfOfertasDemandas"
              :label="$t('label.notificacionOfertasDemandas')"
              @change="getClientes()"
            ></PFormSwitch>
          </PCol>
          <PCol md="12" v-if="valueLocal.ntfOfertasDemandas && valueLocal.pais > 0">
            <PFormSelectTranslateItems
              v-model="valueLocal.clientesNotificados"
              :options="optionsClientes"
              :sortLeft="false"
              optionValue="id"
              optionText="codDesCliente"
              :titleLeft="$t('label.cliente')"
              :titleRight="$t('label.seleccionados')"
            ></PFormSelectTranslateItems>
          </PCol>
        </PRow>
      </div>
    </template>
  </PForm>
</template>
<script lang="ts">
import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import { ICliente, IDelegacion, IPais } from "@/entities";
import { IClienteParams, iniClienteParams, IRespuestaBuscarEntidad } from "@/services";
import { Getter } from "vuex-class";
import { AxiosResponse } from "axios";

@Component({
  components: {},
})
export class ClienteForm extends Vue {
  @Prop({ required: true }) value!: IClienteParams;

  @Watch("value", { immediate: true, deep: true })
  onChangeValue(): void {
    this.valueLocal = JSON.parse(JSON.stringify(this.value));
  }

  @Prop({ required: false }) actionName!: string;
  @Prop({ required: false }) textActionName!: string;
  @Getter("getPaises") getPaises!: IPais[];
  valueLocal: IClienteParams = iniClienteParams;
  optionsPaises: IPais[] = [];
  optionsDelegaciones: IDelegacion[] = [];
  validado = false;
  optionsClientes: ICliente[] = [];

  async mounted(): Promise<void> {
    if (this.actionName === "crear") {
      this.valueLocal.expirationTime = "17:00";
      this.valueLocal.intraDay = false;
    }
    this.optionsPaises = this.getPaises;
    this.fetchDelegaciones();
    if (this.valueLocal.ntfOfertasDemandas) {
      this.getClientes();
    }
  }

  getClientes(): void {
    if (this.valueLocal.ntfOfertasDemandas && this.valueLocal.pais) {
      if (Array.isArray(this.valueLocal.clientesNotificados)) {
        this.valueLocal.clientesNotificados = this.valueLocal.clientesNotificados
          .map((c: any) => c?.id)
          .filter((id): id is number => typeof id === "number");
      }
      this.$services.clientes.fetchClientesByPais(this.valueLocal.pais).then((response) => {
        if (response) {
          let clientesFiltrados = response.filter(
            (cliente) => cliente.codCliente !== this.valueLocal.codCliente
          );

          clientesFiltrados.forEach((cliente) => {
            cliente.codDesCliente = cliente.codCliente + " - " + cliente.desCliente;
          });

          this.optionsClientes = clientesFiltrados;

          const idsSeleccionados = this.valueLocal.clientesNotificados ?? [];

          this.valueLocal.clientesNotificados = clientesFiltrados
            .map((c) => c.id)
            .filter((id): id is number => typeof id === "number" && idsSeleccionados.includes(id));
        }
      });
    }
  }

  fetchDelegaciones(): void {
    this.$services.pais._fetchDelegaciones(this.valueLocal.pais).then((response) => {
      if (response) {
        this.optionsDelegaciones = response.content;
      }
    });
  }

  validarCliente(): void {
    this.$services.clientes
      ._fetchValidateCliente({
        idPais: this.valueLocal.pais,
        codCliente: this.valueLocal.codCliente,
      })
      .then((response?: AxiosResponse<IRespuestaBuscarEntidad>) => {
        if (response?.status === 208) {
          this.$swal({
            icon: "info",
            title: this.$t("administracion.cliente.yaExiste.title"),
            html: this.$t("administracion.cliente.yaExiste.message"),
          });
        } else if (response?.data?.exito) {
          this.valueLocal.desCliente = response.data.entidad.desNombre;
        } else {
          this.$swal({
            icon: "warning",
            title: this.$t("administracion.cliente.noEncontrado.title"),
            html: this.$t("administracion.cliente.noEncontrado.message"),
          });
        }
      });
  }

  cancel(): void {
    this.$emit("cancel");
  }

  action(action: string): void {
    this.$emit("action", { data: this.valueLocal, action: action });
  }
}

export default ClienteForm;
</script>
<style lang="scss" scoped>
.divBotonValidar_ClienteForm {
  text-align: right;
  display: flex;
  justify-content: flex-end;
}
</style>
